module.exports = __webpack_public_path__ + "static/img/img_cabinet.6b07f3f9.png";